import { render, staticRenderFns } from "./Pos_add_product_service.vue?vue&type=template&id=3c1f37b4&scoped=true&"
import script from "./Pos_add_product_service.vue?vue&type=script&lang=js&"
export * from "./Pos_add_product_service.vue?vue&type=script&lang=js&"
import style0 from "./Pos_add_product_service.vue?vue&type=style&index=0&id=3c1f37b4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1f37b4",
  null
  
)

export default component.exports